import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/interfaces/api-response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OtpService {

    private apiURL = environment.appApiUrl + "otp/";

    constructor(private http: HttpClient) { }

    askOtp(ref: string): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(this.apiURL + 'send', null);
    }

    async checkOtp(otp: string) : Promise<ApiResponse> {
        return this.http.get<ApiResponse>(this.apiURL + 'check/' + otp).toPromise();
    }

}
